var map = {
	"./ar/locale": [
		19860,
		9860
	],
	"./en/locale": [
		3844,
		3844
	],
	"./es/locale": [
		23395,
		3395
	],
	"./sv/locale": [
		73418,
		3418
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 96634;
module.exports = webpackAsyncContext;